import React, { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.svg";
import { Player } from "@lottiefiles/react-lottie-player";
import backgroundAnimation from "../../animations/Animation5.json";
import { useSelector } from "react-redux";
import Loader from "../../components/Loader";
import API from "../../constants/apiConfig";

function HomePage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [seenList, setSeenList] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
    const fetchPhases = async () => {
      try {
        const response = await fetch(`${API.GET_LEVELS_AND_DATA}${user.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            arkv: "!$Learn#$!",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("data", data);
        setSeenList(data.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setPageLoading(false);
      }
    };

    fetchPhases();
  }, [user]);

  const handleResumeClick = () => {
    navigate("/phase-selection");
  };

  if (pageLoading) return <Loader />;
  return (
    <div className="main-page">
      <div className="background-animation">
        <Player autoplay loop src={backgroundAnimation} />
      </div>

      <Card className="auth-card">
        <Card.Body>
          <div className="text-center mb-4">
            <img src={logo} alt="Game Illustration" className="auth-logo" />
          </div>
          <h2 className="text-center auth-heading">Join the Adventure!</h2>
          <p className="text-center auth-subtext">
            Learn to manage money and play fun challenges.
          </p>
          <div
            style={{
              display: "inline-block",
              width: "100%",
              cursor: seenList.length === 0 ? "not-allowed" : "pointer",
            }}
          >
            <Button
              variant="primary"
              onClick={() => handleResumeClick()}
              className="w-100 mb-3 button"
              disabled={seenList.length === 0}
              style={{
                backgroundColor: seenList.length === 0 ? "#ccc" : "#007bff",
                pointerEvents: seenList.length === 0 ? "none" : "auto",
              }}
            >
              Resume
            </Button>
          </div>

          <Link to="/videos">
            <Button variant="primary" type="submit" className="w-100 button">
              New Game
            </Button>
          </Link>
        </Card.Body>
      </Card>
    </div>
  );
}

export default HomePage;
